import React from 'react';
import PropTypes from "prop-types";
import { EuiCode, EuiCodeBlock } from '../../../../src/components/code';
import { EuiCopy } from '../../../../src/components/copy';
import { EuiFlexGroup, EuiFlexItem } from '../../../../src/components/flex';
import { EuiText } from '../../../../src/components/text';
import { EuiSplitPanel } from '../../../../src/components/panel';
export var LANGUAGES = ['javascript', 'html'];
export var UtilityClassesSection = ({
  code,
  description,
  example,
  snippet
}) => {
  return <EuiFlexGroup>
      <EuiFlexItem>
        <EuiText size="s">
          <h3>
            <EuiCopy textToCopy={code}>
              {copy => <button onClick={copy}>
                  <EuiCode language="html" className="eui-textInheritColor">
                    {code}
                  </EuiCode>
                </button>}
            </EuiCopy>
          </h3>
          {description}
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiSplitPanel.Outer style={{
        overflow: 'hidden'
      }}>
          <EuiSplitPanel.Inner>{example}</EuiSplitPanel.Inner>
          <EuiSplitPanel.Inner color="subdued">
            {snippet && <EuiCodeBlock isCopyable={true} paddingSize="none" transparentBackground={true} language="html">
                {snippet}
              </EuiCodeBlock>}
          </EuiSplitPanel.Inner>
        </EuiSplitPanel.Outer>
      </EuiFlexItem>
    </EuiFlexGroup>;
};
UtilityClassesSection.propTypes = {
  code: PropTypes.string.isRequired,
  description: PropTypes.node,
  example: PropTypes.node,
  snippet: PropTypes.node
};

try {
  UtilityClassesSection.__docgenInfo = {
    description: '',
    displayName: 'UtilityClassesSection',
    methods: [],
    props: {
      code: {
        defaultValue: null,
        description: '',
        name: 'code',
        parent: undefined,
        required: true,
        type: {
          name: 'string'
        }
      },
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      example: {
        defaultValue: null,
        description: '',
        name: 'example',
        parent: undefined,
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      snippet: {
        defaultValue: null,
        description: '',
        name: 'snippet',
        parent: undefined,
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}